var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAngleLeft = function SvgAngleLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M5.3449694,16.0692442 C4.95444511,16.4597685 4.32128013,16.4597685 3.93075584,16.0692442 C3.54023154,15.6787199 3.54023154,15.0455549 3.93075584,14.6550306 L9.93075584,8.6550306 C10.3093348,8.27645166 10.9189212,8.26320604 11.3135872,8.62498324 L18.0692501,14.6563654 C18.476369,15.0295578 18.503872,15.6621252 18.1306796,16.0692442 C17.7574872,16.4763632 17.1249198,16.5038661 16.7178008,16.1306737 L10.6679384,10.7462752 L5.3449694,16.0692442 Z",
    transform: "matrix(0 1 1 0 -1.362 1.362)"
  }))));
};
export default SvgAngleLeft;